import type {
  ContractorModelFragment,
  UpdateContractorInput,
} from "@src/__generated__/urql-graphql";

export class Contractor {
  id: ContractorModelFragment["id"];
  is_vat_payer: ContractorModelFragment["is_vat_payer"];
  iban: ContractorModelFragment["iban"];
  legal_name: ContractorModelFragment["legal_name"];
  street: ContractorModelFragment["street"];
  city: ContractorModelFragment["city"];
  zip: ContractorModelFragment["zip"];
  tax_no: ContractorModelFragment["tax_no"];
  vat_no: ContractorModelFragment["vat_no"];
  national_id: ContractorModelFragment["national_id"];
  registration_no: ContractorModelFragment["registration_no"];
  swift: ContractorModelFragment["swift"];
  country: ContractorModelFragment["country"];
  defaultAccountingAccount: ContractorModelFragment["defaultAccountingAccount"];
  business_form: ContractorModelFragment["business_form"];
  bank_account: ContractorModelFragment["bank_account"];
  bank_account_code: ContractorModelFragment["bank_account_code"];

  constructor(src: Omit<ContractorModelFragment, "__typename">) {
    this.id = src.id;
    this.registration_no = src.registration_no;
    this.is_vat_payer =
      typeof src.is_vat_payer === "boolean"
        ? src.is_vat_payer
        : Boolean(src.vat_no);
    this.iban = src.iban;
    this.legal_name = src.legal_name;
    this.street = src.street;
    this.city = src.city;
    this.zip = src.zip;
    this.tax_no = src.tax_no;
    this.vat_no = src.vat_no;
    this.national_id = src.national_id;
    this.swift = src.swift;
    this.country = src.country;
    this.defaultAccountingAccount = src.defaultAccountingAccount;
    this.business_form = src.business_form;
    this.bank_account = src.bank_account;
    this.bank_account_code = src.bank_account_code;
  }

  public serialize(): UpdateContractorInput {
    return {
      id: this.id,
      legal_name: this.legal_name,
      street: this.street,
      city: this.city,
      zip: this.zip,
      tax_no: this.tax_no,
      vat_no: this.vat_no,
      iban: this.iban,
      swift: this.swift,
      country_id: this.country?.id,
      default_accounting_account_id: this.defaultAccountingAccount?.id,
      business_form: this.business_form,
      national_id: this.national_id,
      registration_no: this.registration_no,
      bank_account: this.bank_account,
      bank_account_code: this.bank_account_code,
    };
  }
}
